import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetSurveyBasicList = (filterValue, clientId) => {
  const [surveys, setSurveys] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(filterValue);
  const [clientFilter, setClientFilter] = useState(clientId);
  const [totalLength, setTotalLength] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("id");

  const getSurveys = async () => {
    if (search === "") {
      setIsLoading(true);
    }

    try {
      let data = await TLinkApi.get(
        `/survey?search=${search}&filter=${filter}&page=${page}&limit=${entriesPerPage}&clientFilter=${clientFilter}&sortOrder=${sortOrder}&sortBy=${sortBy}`
      );
      setSurveys(data.data.surveyData);
      setTotalLength(data.data.totalLenght);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getSurveys();
    // eslint-disable-next-line
  }, [page, search, filter, clientFilter, entriesPerPage, sortBy, sortOrder]);

  return {
    surveys,
    getSurveys,
    isLoading,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    setFilter,
    clientFilter,
    setClientFilter,
    filter,
    setEntriesPerPage,
    entriesPerPage,
    setSortOrder,
    setSortBy,
    sortBy,
    sortOrder,
    setIsLoading,
  };
};

export default GetSurveyBasicList;
